module.exports = __webpack_public_path__ + "static/media/hand-holding-water.b8761a72.svg";